import { DateParse } from 'utils/DateParse';

export const useFormData = () => {
	const getItemValueFromCookies = (key: string, startsWith: boolean = false): string | undefined => {
		const cookies = document.cookie.split(';').map(cookie => cookie.trim());
		if (startsWith) {
			return cookies.find(value => value.startsWith(key))?.split('=')[1];
		} else {
			return cookies.find(value => value.includes(key))?.split('=')[1];
		}
	};

	const setInitialVariablesForm = (formData: any): void => {
		// Buscamos cualquier cookie que comience con _ga_
		/*let gaCookie = getItemValueFromCookies('_ga_', true);

		if (gaCookie !== undefined) {
			const parts = gaCookie.split('s');
			if (parts.length > 1) {
				formData.gid = parts[1].split('$')[0];
			} else {
				formData.gid = gaCookie;
			}
		} else {
			formData.gid = getItemValueFromCookies('_ga');
		}*/
		const ga_Cookie = getItemValueFromCookies('_ga_MCPHL42NFF');

		formData.gidnew = ga_Cookie
		formData.gid = getItemValueFromCookies('_ga');
		formData.fbc = getItemValueFromCookies('_fbc');
		formData.fbp = getItemValueFromCookies('_fbp');
		formData.userAgent = navigator.userAgent;
	};

	const formatFormData = (formData: any): any => {
		let formatedFormData = formData;
		if (formatedFormData.dateOfEmployment) {
			formatedFormData.dateOfEmployment = DateParse(formatedFormData.dateOfEmployment);
		}
		if (formatedFormData.nationalId) {
			formatedFormData.nationalId = formatedFormData.nationalId.replaceAll('.', '');
		}
		if (formatedFormData.vehiclePlate) {
			formatedFormData.vehiclePlate = [formatedFormData.vehiclePlate];
		}

		return formatedFormData;
	};

	return { formatFormData, setInitialVariablesForm } as const;
};
